import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router';
import { AlertCircle, Home } from 'lucide-react';

export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let errorMessage: string;
  let errorStatus: number | undefined;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || 'An error occurred';
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else {
    errorMessage = 'Unknown error occurred';
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-8 h-8 text-red-600" />
        </div>
        
        {errorStatus && (
          <h1 className="text-4xl font-bold text-gray-900 mb-2">{errorStatus}</h1>
        )}
        
        <h2 className="text-xl font-bold text-gray-900 mb-4">
          {errorStatus === 404 ? 'Sayfa Bulunamadı' : 'Bir Hata Oluştu'}
        </h2>
        
        <p className="text-gray-600 mb-6">{errorMessage}</p>
        
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
        >
          <Home className="w-5 h-5" />
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
}
